export { default as translations } from './translations.json';
export const MAX_RECIPIENTS = 500;
